module.exports = __webpack_public_path__ + "a82d548735c1d4192465681dfc0b6deb.png";


//////////////////
// WEBPACK FOOTER
// ./public/pic_3@2x.png
// module id = 214
// module chunks = 1